import React from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { createLDContexts } from 'app/frontend/javascripts/helpers/launchdarkly';

function LaunchDarklyProvider({ children }: { children: React.ReactNode }) {
  return (
    <LDProvider
      clientSideID={process.env.LAUNCHDARKLY_JS_KEY}
      reactOptions={{
        useCamelCaseFlagKeys: false,
      }}
      context={createLDContexts(
        window.gon.current_user_json?.id,
        window.gon.current_user_json?.company_id,
      )}
    >
      {children}
    </LDProvider>
  );
}

export default LaunchDarklyProvider;
